import 'regenerator-runtime/runtime';
import { put, call, takeEvery, takeLatest, all } from 'redux-saga/effects';
import {
  search,
  create,
  update,
  getById,
  makeActive,
  makeInActive,
  checkFromHomeOwner,
  checkPreOrientation,
  unCheckFromHomeOwner,
  unCheckPreOrientation,
  getSelectListItem,
  getHomeOwnerRequestTypeList,
  checkBeforeUpdateRequestType
} from './api';
import * as RequestTypeActionType from './constants';
import * as NotifyActionType from '../constants/notification-action-type';

export function* getByIdAsync(action) {

  const result = yield call(getById, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: RequestTypeActionType.GET_REQUEST_TYPE_BY_ID_SUCCESS, data: result.data });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* searchAsync(action) {
  const result = yield call(search, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: RequestTypeActionType.SEARCH_REQUEST_TYPE_SUCCESS,
      data: {
        data: result.data,
        params: action.params
      }
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* createAsync(action) {

  const result = yield call(create, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: RequestTypeActionType.SEARCH_REQUEST_TYPE_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Request type created' })
    ];
    if (action.callback) {action.callback();}
  } else {
    yield put({ type: RequestTypeActionType.ADD_EDIT_REQUEST_TYPE_ERROR, data: { error: result.data, params: action.params.data } });
  }
}

export function* checkBeforeUpdateRequestTypeAsync(action) {
  const result = yield call(checkBeforeUpdateRequestType, action.data);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.callback) {
      action.callback(result.data);
    }
  }
}

export function* updateAsync(action) {
  const result = yield call(update, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: RequestTypeActionType.SEARCH_REQUEST_TYPE_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];

    if (action.callback) {
      action.callback();
    }
  } else if (statusCode === 400) {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: 'This request type is already in use. You can\'t modify this attribute anymore.' });
  }
  else {
    yield put({ type: RequestTypeActionType.ADD_EDIT_REQUEST_TYPE_ERROR, data: { error: result.data, params: action.params.data } });
  }
}

export function* makeActiveAsync(action) {

  const result = yield call(makeActive, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: RequestTypeActionType.SEARCH_REQUEST_TYPE_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: { data: result.data } });
  }
}

export function* makeInActiveAsync(action) {
  const result = yield call(makeInActive, action.params.data);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: RequestTypeActionType.SEARCH_REQUEST_TYPE_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: { data: result.data } });
  }
}

export function* checkPreOrientationAsync(action) {

  const result = yield call(checkPreOrientation, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: RequestTypeActionType.SEARCH_REQUEST_TYPE_ASYNC, params: action.params.search })
      // put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
    if (!result.data.fromHomeOwner) {
      yield put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' });
    }
    if (action.callback) { action.callback(true); }
  } else {
    yield [
      put({ type: RequestTypeActionType.SEARCH_REQUEST_TYPE_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error })
    ];
  }
}

export function* unCheckPreOrientationAsync(action) {

  const result = yield call(unCheckPreOrientation, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: RequestTypeActionType.SEARCH_REQUEST_TYPE_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
    // if (!result.data.fromHomeOwner) {
    //   yield put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' });
    // }
    if (action.callback) { action.callback(true); }
  } else {
    yield [
      put({ type: RequestTypeActionType.SEARCH_REQUEST_TYPE_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error })
    ];
  }
}

export function* checkFromHomeOwnerAsync(action) {

  const result = yield call(checkFromHomeOwner, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: RequestTypeActionType.SEARCH_REQUEST_TYPE_ASYNC, params: action.params.search })
      // put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
    if (!result.data.preOrientation) {
      yield put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' });
    }
    if (action.callback) { action.callback(true); }
  } else {
    yield [
      put({ type: RequestTypeActionType.SEARCH_REQUEST_TYPE_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error })
    ];
  }
}

export function* unCheckFromHomeOwnerAsync(action) {

  const result = yield call(unCheckFromHomeOwner, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: RequestTypeActionType.SEARCH_REQUEST_TYPE_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
    // if (!result.data.preOrientation) {
    //   yield put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' });
    // }
    if (action.callback) { action.callback(true); }
  } else {
    yield [
      put({ type: RequestTypeActionType.SEARCH_REQUEST_TYPE_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error })
    ];
  }
}

export function* selectListItemAsync(action) {

  const result = yield call(getSelectListItem, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.callback) {
      action.callback();
    }
    yield [
      put({ type: RequestTypeActionType.SELECT_LIST_ITEM_SUCCESS, data: result.data })
    ];
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    if (action.callback) {
      action.callback();
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getHomeOwnerRequestTypeListAsync(action) {
  const result = yield call(getHomeOwnerRequestTypeList, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.callback) {
      action.callback(true, result.data);
    }
    yield [
      put({ type: RequestTypeActionType.GET_HOMEOWNER_REQUEST_TYPE_LIST_SUCCESS, data: result.data })
    ];
  } else {
    if (action.callback) {
      action.callback(false);
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* onCheckHomeOwnerRequestTypeAsync(action) {
  const result = yield call(onCheckHomeOwnerRequestType, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: 'Error'});
  }
}

export function* onCheckBuyerOrientationRequestTypeAsync(action) {
  const result = yield call(onCheckBuyerOrientationRequestType, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: 'Error'});
  }
}

export default function* WatchRequestTypes() {
  yield all([
    takeLatest(RequestTypeActionType.SEARCH_REQUEST_TYPE_ASYNC, searchAsync),
    takeLatest(RequestTypeActionType.GET_REQUEST_TYPE_BY_ID_ASYNC, getByIdAsync),
    takeEvery(RequestTypeActionType.CREATE_REQUEST_TYPE_ASYNC, createAsync),
    takeEvery(RequestTypeActionType.CHECK_BEFORE_UPDATE_REQUEST_TYPE_ASYNC, checkBeforeUpdateRequestTypeAsync),
    takeEvery(RequestTypeActionType.UPDATE_REQUEST_TYPE_ASYNC, updateAsync),
    takeEvery(RequestTypeActionType.MAKE_ACTIVE_REQUEST_TYPE_ASYNC, makeActiveAsync),
    takeEvery(RequestTypeActionType.MAKE_INACTIVE_REQUEST_TYPE_ASYNC, makeInActiveAsync),
    takeEvery(RequestTypeActionType.CHECK_PRE_ORIENTATION_REQUEST_TYPE_ASYNC, checkPreOrientationAsync),
    takeEvery(RequestTypeActionType.UNCHECK_PRE_ORIENTATION_REQUEST_TYPE_ASYNC, unCheckPreOrientationAsync),
    takeEvery(RequestTypeActionType.CHECK_FROM_HOME_OWNER_REQUEST_TYPE_ASYNC, checkFromHomeOwnerAsync),
    takeEvery(RequestTypeActionType.UNCHECK_FROM_HOME_OWNER_REQUEST_TYPE_ASYNC, unCheckFromHomeOwnerAsync),
    takeLatest(RequestTypeActionType.SELECT_LIST_ITEM_ASYNC, selectListItemAsync),
    takeLatest(RequestTypeActionType.GET_HOMEOWNER_REQUEST_TYPE_LIST_ASYNC, getHomeOwnerRequestTypeListAsync)
  ]);
}



// WEBPACK FOOTER //
// ./src/Request-Types/saga.js